import type {Context} from '../types';

export default function (context: Context) {
  const {jsonNode} = context.node;

  const isDynamoWrapper =
    jsonNode.type === 'DynamoWrapper' || jsonNode.data?.dyn?.type === 'wrapper';

  const dataDynQueryCuratedIds = jsonNode.data?.dyn?.query?.curatedIds;

  const hasValidCuratedIds =
    dataDynQueryCuratedIds != null && Array.isArray(dataDynQueryCuratedIds);

  const isNeeded = isDynamoWrapper && hasValidCuratedIds;

  return {
    needed: isNeeded,
    logData: {
      msg: 'Dynamo Wrapper Curated Collection Lists migration',
      meta: {
        nodeId: jsonNode._id,
      },
    },
    apply: () => {
      if (
        dataDynQueryCuratedIds == null ||
        !Array.isArray(dataDynQueryCuratedIds)
      ) {
        return;
      }
      if (!jsonNode.data) {
        jsonNode.data = {};
      }
      if (!jsonNode.data.dyn) {
        jsonNode.data.dyn = {};
      }
      if (!jsonNode.data.dyn.query) {
        jsonNode.data.dyn.query = {};
      }
      if (dataDynQueryCuratedIds) {
        jsonNode.data.dyn.query.curated = {};
        jsonNode.data.dyn.query.curated.itemIds = dataDynQueryCuratedIds;
        // eslint-disable-next-line webflow/no-delete
        delete jsonNode.data.dyn.query.curatedIds;
      }
    },
  };
}
